import { render } from "./AnnotatorsReportsList.vue?vue&type=template&id=32a9e843&scoped=true"
import script from "./AnnotatorsReportsList.vue?vue&type=script&lang=js"
export * from "./AnnotatorsReportsList.vue?vue&type=script&lang=js"

import "./AnnotatorsReportsList.vue?vue&type=style&index=0&id=32a9e843&scoped=true&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a9e843"]])

export default __exports__